"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Example: Each project has a 50% chance of getting picked as
// the lower bound is inclusive, and the upper bound is exclusive.
//
// const projects = [
//   {
//     projectId: 1,
//     probabilityLowerBound: 0,
//     probabilityUpperBound: 5001,
//   },
//   {
//     projectId: 2,
//     probabilityLowerBound: 5001,
//     probabilityUpperBound: 10001,
//   }
// ]
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJlZS1wcm9qZWN0LWNob2ljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90cmVlLXByb2plY3RzL3RyZWUtcHJvamVjdC1jaG9pY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFNQSw4REFBOEQ7QUFDOUQsa0VBQWtFO0FBQ2xFLEVBQUU7QUFDRixxQkFBcUI7QUFDckIsTUFBTTtBQUNOLG9CQUFvQjtBQUNwQixnQ0FBZ0M7QUFDaEMsbUNBQW1DO0FBQ25DLE9BQU87QUFDUCxNQUFNO0FBQ04sb0JBQW9CO0FBQ3BCLG1DQUFtQztBQUNuQyxvQ0FBb0M7QUFDcEMsTUFBTTtBQUNOLElBQUkifQ==